import type { V4Theme } from '../../components-v4/theme';
import { IRequestStatus } from '../../types';

type colorsVariants = 'dot' | 'square';
type StatusColorsMap = Record<IRequestStatus, Record<colorsVariants, string>>;

export const statusColorsMap = (
  colors: V4Theme['colors']
): StatusColorsMap => ({
  accepted: {
    dot: colors.primary[400],
    square: colors.primary[100],
  },
  run: {
    dot: colors.orange[400],
    square: colors.orange[100],
  },
  delayed: {
    dot: colors.gray[400],
    square: colors.gray[100],
  },
  refusal: {
    dot: colors.red[400],
    square: colors.red[100],
  },
  abandonment: {
    dot: colors.red[400],
    square: colors.red[100],
  },
  performed: {
    dot: colors.green[400],
    square: colors.green[100],
  },
});
